import { useQueryClient } from '@tanstack/react-query';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import { checkoutKeys } from '@/features/profile/hooks/useCheckout';
import { tokenKeys } from '@/features/profile/hooks/useTokens';

/**
 * Portal return page - invalidates cached data and redirects to profile
 *
 * When users return from the Stripe billing portal, this page ensures
 * any subscription or token changes are reflected by invalidating
 * the relevant queries before redirecting back to the profile.
 */
export default function PortalReturnPage() {
  const queryClient = useQueryClient();
  const navigate = useNavigate();

  useEffect(() => {
    // Invalidate subscription and token queries to reflect any changes
    queryClient.invalidateQueries({ queryKey: tokenKeys.balance() });
    queryClient.invalidateQueries({ queryKey: tokenKeys.history() });
    queryClient.invalidateQueries({ queryKey: checkoutKeys.subscription() });

    // Redirect to profile
    navigate('/profile', { replace: true });
  }, [queryClient, navigate]);

  // Brief loading state while redirecting
  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-900 via-purple-900 to-slate-900 flex items-center justify-center">
      <div className="animate-pulse text-purple-300">Returning to profile...</div>
    </div>
  );
}
